import './assets/css/mantine.css';

import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { IntercomProvider } from 'react-use-intercom';
import { ClientContextProvider } from '@/shell/ClientContext/ClientContextProvider';
import { getAppConfig } from '@/app/config';
import { store } from '@/app/store';
import App from './views/App';
import en_US from './assets/lang/en-US';
import pt_PT from './assets/lang/pt-PT';
import { resolver, useTheme } from './assets/styles/themeMantine';
import { LaunchDarklyWrapper } from './LaunchDarklyWrapper';
import { GeolocateProvider } from '@/features/geolocateProvider';
import { HoverProvider } from '@/features/hoverProvider';

import { AuthProvider } from '@/shell/auth/AuthProvider';

const locale = navigator.language;
let lang = en_US;

if (locale === 'pt-PT') {
  lang = pt_PT;
}

export const Root = () => {
  const theme = useTheme();

  return (
    <Provider store={store}>
      <IntercomProvider appId={getAppConfig().intercomId} autoBoot>
        <AuthProvider>
          <ClientContextProvider>
            <LaunchDarklyWrapper>
              <GeolocateProvider>
                <HoverProvider>
                  <IntlProvider locale={locale} messages={lang}>
                    <MantineProvider
                      theme={theme}
                      cssVariablesResolver={resolver}
                    >
                      <ModalsProvider>
                        <App />
                      </ModalsProvider>
                    </MantineProvider>
                  </IntlProvider>
                </HoverProvider>
              </GeolocateProvider>
            </LaunchDarklyWrapper>
          </ClientContextProvider>
        </AuthProvider>
      </IntercomProvider>
    </Provider>
  );
};
